import { render, staticRenderFns } from "./addedit-question.vue?vue&type=template&id=00211002&scoped=true"
import script from "./addedit-question.vue?vue&type=script&lang=js"
export * from "./addedit-question.vue?vue&type=script&lang=js"
import style0 from "./addedit-question.vue?vue&type=style&index=0&id=00211002&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00211002",
  null
  
)

export default component.exports